/**
 * @generated SignedSource<<68f6b75615af4c2b8ea65b98d8e1edc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppUtils_getLocationFragment$data = {
  readonly chatChannel: {
    readonly id: string;
  } | null;
  readonly collection: {
    readonly id: string;
  } | null;
  readonly contentUsage: {
    readonly id: string;
  } | null;
  readonly customAppUrl: string | null;
  readonly feed: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly kind: ProductAppKind;
  readonly linkProduct: {
    readonly slug: string;
  } | null;
  readonly product: {
    readonly slug: string;
  } | null;
  readonly " $fragmentType": "AppUtils_getLocationFragment";
};
export type AppUtils_getLocationFragment$key = {
  readonly " $data"?: AppUtils_getLocationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppUtils_getLocationFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AppUtils_getLocationFragment"
};

(node as any).hash = "017f58fd49facc62614f48ee24516d07";

export default node;
